var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCurrentLocationMarker = function SvgCurrentLocationMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.945 11.7C2.72 10.195 0 6.548 0 4.5a4.5 4.5 0 1 1 9 0c0 2.048-2.742 5.695-3.945 7.2a.708.708 0 0 1-1.11 0ZM4.5 6C5.327 6 6 5.327 6 4.5S5.327 3 4.5 3 3 3.673 3 4.5 3.673 6 4.5 6Z",
    fill: "#39B6E2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 1.688,
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h9v12H0z"
  })))));
};
export { SvgCurrentLocationMarker as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDkgMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8yNTEzXzczNjgwKSI+CjxwYXRoIGQ9Ik0zLjk0NDUzIDExLjdDMi43MjEwOSAxMC4xOTUzIDAgNi41NDg0NCAwIDQuNUMwIDIuMDE0NjkgMi4wMTQ2OSAwIDQuNSAwQzYuOTg0MzggMCA5IDIuMDE0NjkgOSA0LjVDOSA2LjU0ODQ0IDYuMjU3ODEgMTAuMTk1MyA1LjA1NTQ3IDExLjdDNC43NjcxOSAxMi4wNTg2IDQuMjMyODEgMTIuMDU4NiAzLjk0NDUzIDExLjdaTTQuNSA2QzUuMzI3MzQgNiA2IDUuMzI3MzQgNiA0LjVDNiAzLjY3MjY2IDUuMzI3MzQgMyA0LjUgM0MzLjY3MjY2IDMgMyAzLjY3MjY2IDMgNC41QzMgNS4zMjczNCAzLjY3MjY2IDYgNC41IDZaIiBmaWxsPSIjMzlCNkUyIi8+CjxjaXJjbGUgY3g9IjQuNSIgY3k9IjQuNSIgcj0iMS42ODc1IiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI1MTNfNzM2ODAiPgo8cmVjdCB3aWR0aD0iOSIgaGVpZ2h0PSIxMiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";